import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1AssessmentsList: build.query<
      ApiPortalV1AssessmentsListApiResponse,
      ApiPortalV1AssessmentsListApiArg
    >({
      query: () => ({ url: `/api/portal/v1/assessments/` }),
    }),
    apiPortalV1AssessmentsCreate: build.mutation<
      ApiPortalV1AssessmentsCreateApiResponse,
      ApiPortalV1AssessmentsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/`,
        method: "POST",
        body: queryArg.assessmentPeriod,
      }),
    }),
    apiPortalV1AssessmentsRetrieve: build.query<
      ApiPortalV1AssessmentsRetrieveApiResponse,
      ApiPortalV1AssessmentsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsUpdate: build.mutation<
      ApiPortalV1AssessmentsUpdateApiResponse,
      ApiPortalV1AssessmentsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.assessmentPeriod,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
        },
      }),
    }),
    apiPortalV1AssessmentsPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsPartialUpdateApiResponse,
      ApiPortalV1AssessmentsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedAssessmentPeriod,
      }),
    }),
    apiPortalV1AssessmentsDestroy: build.mutation<
      ApiPortalV1AssessmentsDestroyApiResponse,
      ApiPortalV1AssessmentsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/${queryArg.id}/`,
        method: "DELETE",
        params: {
          debrief_schedule_id: queryArg.debriefScheduleId,
        },
      }),
    }),
    apiPortalV1AssessmentsMetricsRetrieve: build.query<
      ApiPortalV1AssessmentsMetricsRetrieveApiResponse,
      ApiPortalV1AssessmentsMetricsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/${queryArg.pathId}/metrics/`,
        params: {
          id: queryArg.queryId,
        },
      }),
    }),
    apiPortalV1AssessmentsProgressRetrieve: build.query<
      ApiPortalV1AssessmentsProgressRetrieveApiResponse,
      ApiPortalV1AssessmentsProgressRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/${queryArg.pathId}/progress/`,
        params: {
          id: queryArg.queryId,
        },
      }),
    }),
    apiPortalV1AssessmentsSendRemindersCreate: build.mutation<
      ApiPortalV1AssessmentsSendRemindersCreateApiResponse,
      ApiPortalV1AssessmentsSendRemindersCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/${queryArg.id}/send_reminders/`,
        method: "POST",
        body: queryArg.assessmentPeriod,
      }),
    }),
    apiPortalV1AssessmentsAggregateVersionsRetrieve: build.query<
      ApiPortalV1AssessmentsAggregateVersionsRetrieveApiResponse,
      ApiPortalV1AssessmentsAggregateVersionsRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/assessments/aggregate-versions/` }),
    }),
    apiPortalV1AssessmentsCloseCreate: build.mutation<
      ApiPortalV1AssessmentsCloseCreateApiResponse,
      ApiPortalV1AssessmentsCloseCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/close/`,
        method: "POST",
        body: queryArg.closeAssessmentPeriod,
      }),
    }),
    apiPortalV1AssessmentsCompletedRetrieve: build.query<
      ApiPortalV1AssessmentsCompletedRetrieveApiResponse,
      ApiPortalV1AssessmentsCompletedRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/completed/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
        },
      }),
    }),
    apiPortalV1AssessmentsEmergentThemesDetailRetrieve: build.query<
      ApiPortalV1AssessmentsEmergentThemesDetailRetrieveApiResponse,
      ApiPortalV1AssessmentsEmergentThemesDetailRetrieveApiArg
    >({
      query: () => ({
        url: `/api/portal/v1/assessments/emergent-themes/detail/`,
      }),
    }),
    apiPortalV1AssessmentsExportResponsesRetrieve: build.query<
      ApiPortalV1AssessmentsExportResponsesRetrieveApiResponse,
      ApiPortalV1AssessmentsExportResponsesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/export-responses/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
        },
      }),
    }),
    apiPortalV1AssessmentsLeaderboardEventsList: build.query<
      ApiPortalV1AssessmentsLeaderboardEventsListApiResponse,
      ApiPortalV1AssessmentsLeaderboardEventsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/leaderboard-events/`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    apiPortalV1AssessmentsLeaderboardEventsCreate: build.mutation<
      ApiPortalV1AssessmentsLeaderboardEventsCreateApiResponse,
      ApiPortalV1AssessmentsLeaderboardEventsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/leaderboard-events/`,
        method: "POST",
        body: queryArg.assessmentsLeaderboard,
      }),
    }),
    apiPortalV1AssessmentsLeaderboardEventsRetrieve: build.query<
      ApiPortalV1AssessmentsLeaderboardEventsRetrieveApiResponse,
      ApiPortalV1AssessmentsLeaderboardEventsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/leaderboard-events/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsLeaderboardEventsUpdate: build.mutation<
      ApiPortalV1AssessmentsLeaderboardEventsUpdateApiResponse,
      ApiPortalV1AssessmentsLeaderboardEventsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/leaderboard-events/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.assessmentsLeaderboard,
      }),
    }),
    apiPortalV1AssessmentsLeaderboardEventsPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsLeaderboardEventsPartialUpdateApiResponse,
      ApiPortalV1AssessmentsLeaderboardEventsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/leaderboard-events/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedAssessmentsLeaderboard,
      }),
    }),
    apiPortalV1AssessmentsLeaderboardEventsDestroy: build.mutation<
      ApiPortalV1AssessmentsLeaderboardEventsDestroyApiResponse,
      ApiPortalV1AssessmentsLeaderboardEventsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/leaderboard-events/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiPortalV1AssessmentsLeaderboardEventsLinkOpenCreate: build.mutation<
      ApiPortalV1AssessmentsLeaderboardEventsLinkOpenCreateApiResponse,
      ApiPortalV1AssessmentsLeaderboardEventsLinkOpenCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/leaderboard-events/link-open/`,
        method: "POST",
        body: queryArg.assessmentsLeaderboard,
      }),
    }),
    apiPortalV1AssessmentsSurveyExportRetrieve: build.query<
      ApiPortalV1AssessmentsSurveyExportRetrieveApiResponse,
      ApiPortalV1AssessmentsSurveyExportRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/survey-export/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
        },
      }),
    }),
    apiPortalV1AssessmentsTeamCommitmentRetrieve: build.query<
      ApiPortalV1AssessmentsTeamCommitmentRetrieveApiResponse,
      ApiPortalV1AssessmentsTeamCommitmentRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/team-commitment/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          team_id: queryArg.teamId,
        },
      }),
    }),
    apiPortalV1AssessmentsTeamCommitmentCreate: build.mutation<
      ApiPortalV1AssessmentsTeamCommitmentCreateApiResponse,
      ApiPortalV1AssessmentsTeamCommitmentCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/team-commitment/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    apiPortalV1AssessmentsTeamCommitmentRetrieve2: build.query<
      ApiPortalV1AssessmentsTeamCommitmentRetrieve2ApiResponse,
      ApiPortalV1AssessmentsTeamCommitmentRetrieve2ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/team-commitment/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsTeamCommitmentUpdate: build.mutation<
      ApiPortalV1AssessmentsTeamCommitmentUpdateApiResponse,
      ApiPortalV1AssessmentsTeamCommitmentUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/team-commitment/${queryArg.id}/`,
        method: "PUT",
      }),
    }),
    apiPortalV1AssessmentsTeamCommitmentPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsTeamCommitmentPartialUpdateApiResponse,
      ApiPortalV1AssessmentsTeamCommitmentPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/team-commitment/${queryArg.id}/`,
        method: "PATCH",
      }),
    }),
    apiPortalV1AssessmentsTeamCommitmentDestroy: build.mutation<
      ApiPortalV1AssessmentsTeamCommitmentDestroyApiResponse,
      ApiPortalV1AssessmentsTeamCommitmentDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/team-commitment/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiPortalV1AssessmentsTeamCommitmentAvailableMetricsRetrieve: build.query<
      ApiPortalV1AssessmentsTeamCommitmentAvailableMetricsRetrieveApiResponse,
      ApiPortalV1AssessmentsTeamCommitmentAvailableMetricsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/team-commitment/available_metrics/`,
        params: {
          team_id: queryArg.teamId,
        },
      }),
    }),
    apiPortalV1AssessmentsTeamCommitmentTeamBioRetrieve: build.query<
      ApiPortalV1AssessmentsTeamCommitmentTeamBioRetrieveApiResponse,
      ApiPortalV1AssessmentsTeamCommitmentTeamBioRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/team-commitment/team_bio/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          team_id: queryArg.teamId,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1AssessmentsListApiResponse =
  /** status 200  */ AssessmentPeriodRead[];
export type ApiPortalV1AssessmentsListApiArg = void;
export type ApiPortalV1AssessmentsCreateApiResponse =
  /** status 201  */ AssessmentPeriodRead;
export type ApiPortalV1AssessmentsCreateApiArg = {
  assessmentPeriod: AssessmentPeriod;
};
export type ApiPortalV1AssessmentsRetrieveApiResponse =
  /** status 200  */ AssessmentDetails;
export type ApiPortalV1AssessmentsRetrieveApiArg = {
  /** A unique integer value identifying this assessment period. */
  id: number;
};
export type ApiPortalV1AssessmentsUpdateApiResponse =
  /** status 200  */ AssessmentPeriodRead;
export type ApiPortalV1AssessmentsUpdateApiArg = {
  assessmentPeriodId?: number;
  /** A unique integer value identifying this assessment period. */
  id: number;
  assessmentPeriod: AssessmentPeriod;
};
export type ApiPortalV1AssessmentsPartialUpdateApiResponse =
  /** status 200  */ AssessmentPeriodRead;
export type ApiPortalV1AssessmentsPartialUpdateApiArg = {
  /** A unique integer value identifying this assessment period. */
  id: number;
  patchedAssessmentPeriod: PatchedAssessmentPeriod;
};
export type ApiPortalV1AssessmentsDestroyApiResponse = unknown;
export type ApiPortalV1AssessmentsDestroyApiArg = {
  debriefScheduleId?: number;
  /** A unique integer value identifying this assessment period. */
  id: number;
};
export type ApiPortalV1AssessmentsMetricsRetrieveApiResponse =
  /** status 200  */ AssessmentMetrics;
export type ApiPortalV1AssessmentsMetricsRetrieveApiArg = {
  /** A unique integer value identifying this assessment period. */
  pathId: number;
  queryId: number;
};
export type ApiPortalV1AssessmentsProgressRetrieveApiResponse =
  /** status 200  */ AssessmentProgress;
export type ApiPortalV1AssessmentsProgressRetrieveApiArg = {
  /** A unique integer value identifying this assessment period. */
  pathId: number;
  queryId: number;
};
export type ApiPortalV1AssessmentsSendRemindersCreateApiResponse =
  /** status 200  */ any;
export type ApiPortalV1AssessmentsSendRemindersCreateApiArg = {
  /** A unique integer value identifying this assessment period. */
  id: number;
  assessmentPeriod: AssessmentPeriod;
};
export type ApiPortalV1AssessmentsAggregateVersionsRetrieveApiResponse =
  unknown;
export type ApiPortalV1AssessmentsAggregateVersionsRetrieveApiArg = void;
export type ApiPortalV1AssessmentsCloseCreateApiResponse =
  /** status 200  */ any;
export type ApiPortalV1AssessmentsCloseCreateApiArg = {
  closeAssessmentPeriod: CloseAssessmentPeriod;
};
export type ApiPortalV1AssessmentsCompletedRetrieveApiResponse =
  /** status 200  */ AssessmentPeriodSurveyCompletion;
export type ApiPortalV1AssessmentsCompletedRetrieveApiArg = {
  assessmentPeriodId: number;
};
export type ApiPortalV1AssessmentsEmergentThemesDetailRetrieveApiResponse =
  unknown;
export type ApiPortalV1AssessmentsEmergentThemesDetailRetrieveApiArg = void;
export type ApiPortalV1AssessmentsExportResponsesRetrieveApiResponse =
  /** status 200  */ Blob;
export type ApiPortalV1AssessmentsExportResponsesRetrieveApiArg = {
  /** ID of the assessment period to export */
  assessmentPeriodId: number;
};
export type ApiPortalV1AssessmentsLeaderboardEventsListApiResponse =
  /** status 200  */ PaginatedAssessmentsLeaderboardListListRead;
export type ApiPortalV1AssessmentsLeaderboardEventsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type ApiPortalV1AssessmentsLeaderboardEventsCreateApiResponse =
  /** status 201  */ AssessmentsLeaderboardRead;
export type ApiPortalV1AssessmentsLeaderboardEventsCreateApiArg = {
  assessmentsLeaderboard: AssessmentsLeaderboard;
};
export type ApiPortalV1AssessmentsLeaderboardEventsRetrieveApiResponse =
  /** status 200  */ AssessmentsLeaderboardRead;
export type ApiPortalV1AssessmentsLeaderboardEventsRetrieveApiArg = {
  /** A unique integer value identifying this assessment period leaderboard. */
  id: number;
};
export type ApiPortalV1AssessmentsLeaderboardEventsUpdateApiResponse =
  /** status 200  */ AssessmentsLeaderboardRead;
export type ApiPortalV1AssessmentsLeaderboardEventsUpdateApiArg = {
  /** A unique integer value identifying this assessment period leaderboard. */
  id: number;
  assessmentsLeaderboard: AssessmentsLeaderboard;
};
export type ApiPortalV1AssessmentsLeaderboardEventsPartialUpdateApiResponse =
  /** status 200  */ AssessmentsLeaderboardRead;
export type ApiPortalV1AssessmentsLeaderboardEventsPartialUpdateApiArg = {
  /** A unique integer value identifying this assessment period leaderboard. */
  id: number;
  patchedAssessmentsLeaderboard: PatchedAssessmentsLeaderboard;
};
export type ApiPortalV1AssessmentsLeaderboardEventsDestroyApiResponse = unknown;
export type ApiPortalV1AssessmentsLeaderboardEventsDestroyApiArg = {
  /** A unique integer value identifying this assessment period leaderboard. */
  id: number;
};
export type ApiPortalV1AssessmentsLeaderboardEventsLinkOpenCreateApiResponse =
  /** status 200  */ AssessmentsLeaderboardRead;
export type ApiPortalV1AssessmentsLeaderboardEventsLinkOpenCreateApiArg = {
  assessmentsLeaderboard: AssessmentsLeaderboard;
};
export type ApiPortalV1AssessmentsSurveyExportRetrieveApiResponse =
  /** status 200  */ Blob;
export type ApiPortalV1AssessmentsSurveyExportRetrieveApiArg = {
  /** ID of the assessment period to export */
  assessmentPeriodId: number;
};
export type ApiPortalV1AssessmentsTeamCommitmentRetrieveApiResponse = unknown;
export type ApiPortalV1AssessmentsTeamCommitmentRetrieveApiArg = {
  assessmentPeriodId: number;
  teamId: number;
};
export type ApiPortalV1AssessmentsTeamCommitmentCreateApiResponse = unknown;
export type ApiPortalV1AssessmentsTeamCommitmentCreateApiArg = {
  body: {
    team_id: number;
    assessment_period_id: number;
    selected_metrics: number[];
    metric_benchmarks?: object;
    success_criteria_notes?: string;
  };
};
export type ApiPortalV1AssessmentsTeamCommitmentRetrieve2ApiResponse = unknown;
export type ApiPortalV1AssessmentsTeamCommitmentRetrieve2ApiArg = {
  /** A unique integer value identifying this team commitment. */
  id: number;
};
export type ApiPortalV1AssessmentsTeamCommitmentUpdateApiResponse = unknown;
export type ApiPortalV1AssessmentsTeamCommitmentUpdateApiArg = {
  /** A unique integer value identifying this team commitment. */
  id: number;
};
export type ApiPortalV1AssessmentsTeamCommitmentPartialUpdateApiResponse =
  unknown;
export type ApiPortalV1AssessmentsTeamCommitmentPartialUpdateApiArg = {
  /** A unique integer value identifying this team commitment. */
  id: number;
};
export type ApiPortalV1AssessmentsTeamCommitmentDestroyApiResponse = unknown;
export type ApiPortalV1AssessmentsTeamCommitmentDestroyApiArg = {
  /** A unique integer value identifying this team commitment. */
  id: number;
};
export type ApiPortalV1AssessmentsTeamCommitmentAvailableMetricsRetrieveApiResponse =
  unknown;
export type ApiPortalV1AssessmentsTeamCommitmentAvailableMetricsRetrieveApiArg =
  {
    teamId: number;
  };
export type ApiPortalV1AssessmentsTeamCommitmentTeamBioRetrieveApiResponse =
  unknown;
export type ApiPortalV1AssessmentsTeamCommitmentTeamBioRetrieveApiArg = {
  assessmentPeriodId: number;
  teamId: number;
};
export type AssessmentPeriodStatusEnum = 1 | 2 | 3;
export type AssessmentPeriod = {
  name?: string;
  organization: number;
  status?: AssessmentPeriodStatusEnum;
  start_date_time: string;
  end_date_time: string;
  survey_question?: number | null;
  outcome_question?: number | null;
  min_followup_questions?: number;
  max_followup_questions?: number;
  survey_question_structure?: any | null;
  outcome_question_structure?: any | null;
  categories?: any | null;
  /** Enable automated reminder emails. Defaults to True. Schedule inherits from organization.default_reminder_schedule if not set. */
  reminder_enabled?: boolean;
  /** Cron expression for reminder schedule (e.g., '0 9 * * 1,3,5' for Mon/Wed/Fri at 9am in organization's timezone). If not set, inherits from organization.default_reminder_schedule. */
  reminder_schedule?: string | null;
};
export type AssessmentPeriodRead = {
  id: number;
  name?: string;
  organization: number;
  status?: AssessmentPeriodStatusEnum;
  start_date_time: string;
  end_date_time: string;
  survey_question?: number | null;
  outcome_question?: number | null;
  min_followup_questions?: number;
  max_followup_questions?: number;
  survey_question_structure?: any | null;
  outcome_question_structure?: any | null;
  categories?: any | null;
  brief_token: string | null;
  debrief_schedule_id: number | null;
  /** Enable automated reminder emails. Defaults to True. Schedule inherits from organization.default_reminder_schedule if not set. */
  reminder_enabled?: boolean;
  /** Cron expression for reminder schedule (e.g., '0 9 * * 1,3,5' for Mon/Wed/Fri at 9am in organization's timezone). If not set, inherits from organization.default_reminder_schedule. */
  reminder_schedule?: string | null;
};
export type Participant = {
  id: number;
  name: string;
  email: string;
  status: number;
  reminderCount: number;
  lastEmailSentAt?: string | null;
  lastEmailSuccessful?: boolean | null;
  lastEmailStatus?: string | null;
  lastEmailError?: string | null;
  emailHistory?: any | null;
  briefToken?: string | null;
  briefTokenId?: number | null;
};
export type AssessmentDetails = {
  id: number;
  title: string;
  status: number;
  startDate: string;
  endDate: string;
  participants: Participant[];
  completionRate: number;
};
export type PatchedAssessmentPeriod = {
  name?: string;
  organization?: number;
  status?: AssessmentPeriodStatusEnum;
  start_date_time?: string;
  end_date_time?: string;
  survey_question?: number | null;
  outcome_question?: number | null;
  min_followup_questions?: number;
  max_followup_questions?: number;
  survey_question_structure?: any | null;
  outcome_question_structure?: any | null;
  categories?: any | null;
  /** Enable automated reminder emails. Defaults to True. Schedule inherits from organization.default_reminder_schedule if not set. */
  reminder_enabled?: boolean;
  /** Cron expression for reminder schedule (e.g., '0 9 * * 1,3,5' for Mon/Wed/Fri at 9am in organization's timezone). If not set, inherits from organization.default_reminder_schedule. */
  reminder_schedule?: string | null;
};
export type PatchedAssessmentPeriodRead = {
  id?: number;
  name?: string;
  organization?: number;
  status?: AssessmentPeriodStatusEnum;
  start_date_time?: string;
  end_date_time?: string;
  survey_question?: number | null;
  outcome_question?: number | null;
  min_followup_questions?: number;
  max_followup_questions?: number;
  survey_question_structure?: any | null;
  outcome_question_structure?: any | null;
  categories?: any | null;
  brief_token?: string | null;
  debrief_schedule_id?: number | null;
  /** Enable automated reminder emails. Defaults to True. Schedule inherits from organization.default_reminder_schedule if not set. */
  reminder_enabled?: boolean;
  /** Cron expression for reminder schedule (e.g., '0 9 * * 1,3,5' for Mon/Wed/Fri at 9am in organization's timezone). If not set, inherits from organization.default_reminder_schedule. */
  reminder_schedule?: string | null;
};
export type DepartmentScore = {
  department: string;
  score: number;
};
export type AssessmentMetrics = {
  responseRate: number;
  averageScore: number;
  departmentScores: DepartmentScore[];
};
export type DepartmentProgress = {
  department: string;
  completed: number;
  total: number;
};
export type DateProgress = {
  date: string;
  count: number;
};
export type AssessmentProgress = {
  byDepartment: DepartmentProgress[];
  byDate: DateProgress[];
};
export type CloseAssessmentPeriod = {
  assessment_period_id: number;
  overwrite?: boolean;
  aggregate_id: number;
};
export type AssessmentPeriodSurveyCompletion = {
  assessment_period_id: number;
  total_requests: number;
  total_responses: number;
  percent_complete: number;
  department_responses: any;
};
export type AssessmentsLeaderboardList = {};
export type LeaderboardEmployee = {};
export type Status68DEnum = 1 | 2 | 3 | 98 | 99 | 100;
export type LeaderboardEmployeeRead = {
  id: number;
  email: string;
  first_name: string | null;
  last_name: string | null;
  status: Status68DEnum;
};
export type AssessmentsLeaderboardListRead = {
  id: number;
  assessment_period: number;
  leader: LeaderboardEmployeeRead;
  /** Scoring event type, e.g. focus_plan_intervention or post_period_login */
  event_type: string;
  display_event_type: string;
  /** Human-friendly label for the scoring event. */
  event_label: string;
  /** Numeric score contribution for this event. */
  points: number;
  /** When the scoring event occurred or was evaluated. */
  event_date: string | null;
};
export type PaginatedAssessmentsLeaderboardListList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssessmentsLeaderboardList[];
};
export type PaginatedAssessmentsLeaderboardListListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssessmentsLeaderboardListRead[];
};
export type AssessmentsLeaderboard = {
  assessment_period: number;
  organization: number;
  /** Scoring event type, e.g. focus_plan_intervention or post_period_login */
  event_type: string;
  /** Human-friendly label for the scoring event. */
  event_label: string;
  /** Numeric score contribution for this event. */
  points: number;
  /** Optional structured payload for event details. */
  metadata?: any;
  /** When the scoring event occurred or was evaluated. */
  event_date?: string | null;
};
export type EmailStatusEnum = 1 | 2 | 3 | 4 | 9;
export type AccountType71FEnum = 3 | 4 | 5 | 9;
export type SurveyStatus034Enum = 1 | 2;
export type Employee = {
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  status?: Status68DEnum;
  account?: number | null;
  organization: number;
  manager?: number | null;
  department?: number | null;
  email_status?: EmailStatusEnum;
  account_type?: AccountType71FEnum;
  survey_status?: SurveyStatus034Enum;
};
export type EmployeeRead = {
  id: number;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  status?: Status68DEnum;
  account?: number | null;
  organization: number;
  manager?: number | null;
  department?: number | null;
  created_at: string;
  updated_at: string;
  email_status?: EmailStatusEnum;
  email_status_text: string;
  status_text: string;
  account_type?: AccountType71FEnum;
  account_type_text: string;
  survey_status?: SurveyStatus034Enum;
};
export type AssessmentsLeaderboardRead = {
  id: number;
  assessment_period: number;
  organization: number;
  leader: EmployeeRead;
  /** Scoring event type, e.g. focus_plan_intervention or post_period_login */
  event_type: string;
  display_event_type: string;
  /** Human-friendly label for the scoring event. */
  event_label: string;
  /** Numeric score contribution for this event. */
  points: number;
  /** Optional structured payload for event details. */
  metadata?: any;
  /** When the scoring event occurred or was evaluated. */
  event_date?: string | null;
  created_at: string;
  updated_at: string;
};
export type PatchedAssessmentsLeaderboard = {
  assessment_period?: number;
  organization?: number;
  /** Scoring event type, e.g. focus_plan_intervention or post_period_login */
  event_type?: string;
  /** Human-friendly label for the scoring event. */
  event_label?: string;
  /** Numeric score contribution for this event. */
  points?: number;
  /** Optional structured payload for event details. */
  metadata?: any;
  /** When the scoring event occurred or was evaluated. */
  event_date?: string | null;
};
export type PatchedAssessmentsLeaderboardRead = {
  id?: number;
  assessment_period?: number;
  organization?: number;
  leader?: EmployeeRead;
  /** Scoring event type, e.g. focus_plan_intervention or post_period_login */
  event_type?: string;
  display_event_type?: string;
  /** Human-friendly label for the scoring event. */
  event_label?: string;
  /** Numeric score contribution for this event. */
  points?: number;
  /** Optional structured payload for event details. */
  metadata?: any;
  /** When the scoring event occurred or was evaluated. */
  event_date?: string | null;
  created_at?: string;
  updated_at?: string;
};
export const {
  useApiPortalV1AssessmentsListQuery,
  useApiPortalV1AssessmentsCreateMutation,
  useApiPortalV1AssessmentsRetrieveQuery,
  useApiPortalV1AssessmentsUpdateMutation,
  useApiPortalV1AssessmentsPartialUpdateMutation,
  useApiPortalV1AssessmentsDestroyMutation,
  useApiPortalV1AssessmentsMetricsRetrieveQuery,
  useApiPortalV1AssessmentsProgressRetrieveQuery,
  useApiPortalV1AssessmentsSendRemindersCreateMutation,
  useApiPortalV1AssessmentsAggregateVersionsRetrieveQuery,
  useApiPortalV1AssessmentsCloseCreateMutation,
  useApiPortalV1AssessmentsCompletedRetrieveQuery,
  useApiPortalV1AssessmentsEmergentThemesDetailRetrieveQuery,
  useApiPortalV1AssessmentsExportResponsesRetrieveQuery,
  useApiPortalV1AssessmentsLeaderboardEventsListQuery,
  useApiPortalV1AssessmentsLeaderboardEventsCreateMutation,
  useApiPortalV1AssessmentsLeaderboardEventsRetrieveQuery,
  useApiPortalV1AssessmentsLeaderboardEventsUpdateMutation,
  useApiPortalV1AssessmentsLeaderboardEventsPartialUpdateMutation,
  useApiPortalV1AssessmentsLeaderboardEventsDestroyMutation,
  useApiPortalV1AssessmentsLeaderboardEventsLinkOpenCreateMutation,
  useApiPortalV1AssessmentsSurveyExportRetrieveQuery,
  useApiPortalV1AssessmentsTeamCommitmentRetrieveQuery,
  useApiPortalV1AssessmentsTeamCommitmentCreateMutation,
  useApiPortalV1AssessmentsTeamCommitmentRetrieve2Query,
  useApiPortalV1AssessmentsTeamCommitmentUpdateMutation,
  useApiPortalV1AssessmentsTeamCommitmentPartialUpdateMutation,
  useApiPortalV1AssessmentsTeamCommitmentDestroyMutation,
  useApiPortalV1AssessmentsTeamCommitmentAvailableMetricsRetrieveQuery,
  useApiPortalV1AssessmentsTeamCommitmentTeamBioRetrieveQuery,
} = injectedRtkApi;
